var map = {
	"./BRONZE.png": 12148,
	"./CHALLENGER.png": 22945,
	"./CHALLENGER.webp": 60869,
	"./DIAMOND.webp": 30153,
	"./DIAMONG.png": 73634,
	"./EMERALD.webp": 99022,
	"./GOLD.png": 37998,
	"./GOLD.webp": 55061,
	"./GRANDMASTER.png": 27826,
	"./GRANDMASTER.webp": 74532,
	"./IRON.png": 82492,
	"./MASTER.png": 94299,
	"./MASTER.webp": 12763,
	"./PLATINUM.png": 76389,
	"./PLATINUM.webp": 92433,
	"./SILVER.png": 39682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75961;